import Text from '@/common/view/Text';
import { useCustomerDetailPageContext } from '../datacontroller/CustomerDetailPageContext';
import Skeleton from '@/common/view/Skeleton';

export const CustomerNameView = () => {
  const { customerDetail, isCustomerDetailLoading } = useCustomerDetailPageContext();

  if (isCustomerDetailLoading) {
    return (
      <div className="h-10 w-48">
        <Skeleton width="100%" height="100%" />
      </div>
    );
  }

  return (
    <div className="inline-flex items-center">
      <Text typo="h1" color="grayBlack">
        {`${customerDetail?.customer_name}(${customerDetail?.hp_no}) 고객님`}
      </Text>
    </div>
  );
};
